import { LOG_TYPE, logger } from "./dataDog.logger";
import { OIDC, OKTA_SCOPES } from "./OktaUtility";

export const restoreOktaSession = async (props) => {
  const {
    oktaAuth,
    sessionToken,
    redirectUrl,
    callback,
    sessionOnly = false,
  } = props;
  try {
    if (!sessionOnly) {
      const res = await oktaAuth.token.getWithoutPrompt({
        ...(sessionToken && { sessionToken: sessionToken }),
        scopes: OKTA_SCOPES,
      });
      oktaAuth.tokenManager.setTokens(res.tokens);
      if (redirectUrl || sessionToken) {
        window.location.href = `${window.location.origin}${
          redirectUrl ? window.atob(redirectUrl) : ""
        }`;
      }
      cb && cb(true);
    } else {
      const res = await oktaAuth.token.getWithoutPrompt({
        ...(sessionToken && { sessionToken: sessionToken }),
        scopes: OKTA_SCOPES,
      });
      oktaAuth.tokenManager.setTokens(res.tokens);
    }
  } catch (error) {
    logger(`Okta Silent renew failed: ${error}`, {}, LOG_TYPE.error, {
      name: `Okta Silent renew failed: ${error}`,
      message: error,
    });
  }
};
